import { Plus } from 'lucide-react';
import { Trans } from '@lingui/react/macro';
import { useCallback, useState } from 'react';
import { useIsAdmin } from 'shared/hooks/use-is-admin';
import useCreateModal from 'modules/template-editor/ui/hooks/modals/template/create';
import { ButtonWatch, ButtonWrapper, CanvasWrapper, TemplateItemWrapper } from './styles';

interface IProps {}

function NewTemplate(props: IProps) {
  const [isHover, setIsHover] = useState(false);
  const isAdmin = useIsAdmin();

  const { modal: createModal, open: openCreateModal } = useCreateModal();

  const onCreateNewTemplate = useCallback(() => {
    if (!isAdmin) return;
    openCreateModal();
  }, [isAdmin, openCreateModal]);

  return (
    <TemplateItemWrapper>
      <CanvasWrapper
        onClick={onCreateNewTemplate}
        style={{ backgroundColor: 'transparent' }}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
      >
        <ButtonWrapper>
          <ButtonWatch isShow={isHover}>
            <Trans>Добавить новый шаблон</Trans>
          </ButtonWatch>
        </ButtonWrapper>
        <Plus opacity={0.38} size={50} />
      </CanvasWrapper>
      {createModal}
    </TemplateItemWrapper>
  );
}

export default NewTemplate;
